import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiscountHelperService } from '@shared/services/discount-helper.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductDetail, ProductDetailBreadcrumb, ProductDetailBreadcrumbDisplayed, ProductDetailProductObject, ProductDetailVariant } from '../interfaces/product-detail.interface';

const apiUrl = environment.apiUrl+'guest/products/';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailService {

  breadcrumbsDisplayed: ProductDetailBreadcrumbDisplayed[] = [];

  constructor(
    private http: HttpClient,
    private discountHelper: DiscountHelperService,
  ) { }

  getProductDetail(slug: string) {
    return this.http.get(apiUrl+slug).pipe(map((res:any) => {
      let productDetail: ProductDetail = res.data;
      // format
      let product: ProductDetailProductObject = productDetail.product;
      if(product.min_weight) product.min_weight = Number(product.min_weight);
      if(product.max_weight) product.max_weight = Number(product.max_weight);
      if(product.remaining_stock) product.remaining_stock = Number(product.remaining_stock);
      let variants: ProductDetailVariant[] = productDetail.variants;
      variants.forEach(variant => {
        variant.discountPercentage = this.discountHelper.calculateDiscountPercentage(variant.actual_price, variant.unit_price);
      });
      // setup breadcrumbs
      this.setupBreadcrumbsDisplayed(productDetail.breadcrumbs);
      productDetail.breadcrumbsDisplayed = this.breadcrumbsDisplayed.reverse();
      // setup shop est
      productDetail.shop.est = new Date(productDetail.shop.created_at).getFullYear();
      return productDetail;
    })).pipe(catchError((error) => {
      return throwError(error);
    }));
  }

  private setupBreadcrumbsDisplayed(breadcrumbs: ProductDetailBreadcrumb[]) {
    this.breadcrumbsDisplayed = [];
    this.breadcrumbsDisplayed.push({ slug: breadcrumbs[0].slug, name: breadcrumbs[0].name });
  }

}
